const PARTNER_NETWORK_SLUGS = [
    "near",
    "aptos",
    "xdc",
    "ethereum",
    "zksync-era",
    "xrp-ledger",
];

/**
 * @param slug - the slug of the network
 * @returns true if the network is a partner network
 */
export function isPartnerNetwork(props: { slug: string }) {
    const { slug } = props;
    return PARTNER_NETWORK_SLUGS.includes(slug);
}
